import { exitSearch } from 'owa-mail-module-orchestrator';
import { lazySelectFolderNode } from 'owa-mail-folder-forest-actions';
import { orchestrator } from 'satcheljs';
import { getStore as getMailSearchStore } from 'owa-mail-search';

orchestrator(exitSearch, async actionMessage => {
    lazySelectFolderNode.importAndExecute(
        getMailSearchStore().previousNode,
        actionMessage.actionSource
    );
});
